export enum MDSSectionSlotName {
  HeaderRightAddon = "header-right-addon",
  Content = "content",
}

export interface MdsSectionProps extends React.PropsWithChildren {
  /**
   * Optional title for the section
   */
  title?: React.ReactNode;
}
